import React from 'react';

export default function CostingAnalysisTable() {
	return (
		<div className="table-view table-responsive">
			<table id="sales-quotes-charge-table" className="table">
				<thead>
					<tr>
						<th>Transaction Date</th>
						<th>Product Code</th>
						<th>Product Description</th>
						<th>Transaction Type</th>
						<th>Transaction Ref</th>
						<th>Transaction Quantity</th>
						<th>Transaction Unit Cost</th>
						<th>Pre Avg Cost</th>
						<th>Post Avg Cost</th>
						<th>Product Group</th>
					</tr>
				</thead>
				<tbody></tbody>
			</table>
		</div>
	);
}
